import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Phone, Mail, Clock, ExternalLink } from 'lucide-react';
import { AnimatedSection } from '@/hooks/useScrollAnimation';

const ContactBanner = () => {
  return (
    <section className="py-16 md:py-20 lg:py-24 xl:py-28 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <Card className="bg-primary text-white overflow-hidden relative rounded-2xl">
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-accent/10 to-transparent pointer-events-none"></div>
            <div className="absolute bottom-0 left-0 w-1/3 h-1/2 bg-gradient-to-tr from-white/5 to-transparent pointer-events-none"></div>
            
            <CardContent className="relative z-10 p-8 md:p-12 lg:p-16">
              <div className="grid md:grid-cols-2 gap-12 items-center">
                <div>
                  <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium mb-6">
                    Heeft u vragen?
                  </h2>
                  <p className="text-lg text-white/85 mb-8 leading-relaxed">
                    Neem contact op voor meer informatie over verhuur, 
                    onderhoud of uw huurcontract.
                  </p>
                  
                  <div className="space-y-4">
                    <a href="tel:+31646006890" className="flex items-center gap-4 group">
                      <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center group-hover:bg-white/20 transition-colors duration-300">
                        <Phone className="h-5 w-5" />
                      </div>
                      <span className="font-medium text-lg">+31 6 46 00 68 90</span>
                    </a>
                    <a href="mailto:info@croostenburght.nl" className="flex items-center gap-4 group">
                      <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center group-hover:bg-white/20 transition-colors duration-300">
                        <Mail className="h-5 w-5" />
                      </div>
                      <span className="font-medium text-lg">info@croostenburght.nl</span>
                    </a>
                    <div className="flex items-center gap-4">
                      <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center">
                        <Clock className="h-5 w-5" />
                      </div>
                      <span className="font-medium text-lg">Ma - Vr: 9:00 - 17:00</span>
                    </div>
                  </div>
                </div>
                
                <div className="flex flex-col gap-4">
                  <a href="/contact">
                    <Button 
                      size="lg" 
                      className="w-full bg-white text-primary hover:bg-white/90 font-semibold py-6 text-base rounded-xl transition-all duration-300 hover:shadow-luxury hover:-translate-y-1"
                    >
                      <Mail className="mr-2 h-5 w-5" />
                      Stuur een bericht
                    </Button>
                  </a>
                  <a href="https://stichting-croostenburght.vastgoed.app" target="_blank" rel="noopener noreferrer" className="w-full">
                    <Button 
                      size="lg" 
                      variant="outline" 
                      className="w-full border-2 border-white/40 text-white bg-white/5 hover:bg-white hover:text-primary font-semibold backdrop-blur-sm py-6 text-base rounded-xl transition-all duration-300"
                    >
                      <ExternalLink className="mr-2 h-5 w-5" />
                      Huurders Portal
                    </Button>
                  </a>
                </div>
              </div>
            </CardContent>
          </Card>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default ContactBanner;